import React, { useState } from "react";
import { MenuList } from "./menu_list";

function Menu() {
  return (
    <>
      <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
        <div className="space-y-8 px-4 sm:px-6 sm:space-y-6">
          <MenuList />
        </div>
      </div>
    </>
  );
}

export default Menu;
